import graphqlClientFactory from 'lib/graphql-client-factory';

/**
 * Gets an Item.
 *
 * @param {string} query - Query to be executed.
 * @param {string} path - Either the full item path or ShortID.
 * @param {string} language - Optional - the item language version you need. Default is en.
 * @returns {T} The item type requested.
 */
export async function getItem<T>(query: string, path: string, language = 'en') {
  const graphQLClient = graphqlClientFactory();

  try {
    const response = await graphQLClient?.request<T>(query, {
      path: path,
      language,
    });
    if (response) {
      return response;
    }
  } catch (error) {
    console.warn('There was a critical error getting item via graphql.', error);
  }

  return null;
}
